import {
  useCallback,
  useEffect,
  useState,
} from 'react';

import {
  fetchWithRetry,
} from '@/lib/apiRequest';

export interface WhatsAppIntegrationStatus {
  sendConfigured:
    boolean;

  webhookConfigured:
    boolean;

  fullyConfigured:
    boolean;

  missingConfiguration:
    string[];

  phoneNumberId:
    string |
    null;

  graphApiVersion:
    string |
    null;

  webhookPath:
    string;

  totalCommunications:
    number;

  inboundCommunications:
    number;

  outboundCommunications:
    number;

  attentionCommunications:
    number;

  lastInboundAt:
    string |
    null;
}

export function useWhatsAppIntegration() {
  const [
    whatsapp,
    setWhatsApp,
  ] =
    useState<
      WhatsAppIntegrationStatus |
      null
    >(null);

  const [
    isLoadingWhatsApp,
    setIsLoadingWhatsApp,
  ] =
    useState(
      true
    );

  const loadWhatsAppStatus =
    useCallback(
      async () => {
        setIsLoadingWhatsApp(
          true
        );

        try {
          const response =
            await fetchWithRetry(
              '/api/integrations/whatsapp/status'
            );

          const data =
            await response
              .json() as {
              success?:
                boolean;

              error?:
                string;

              whatsapp?:
                WhatsAppIntegrationStatus;
            };

          if (
            !response.ok ||
            !data.success ||
            !data.whatsapp
          ) {
            throw new Error(
              data.error ||
              'Não foi possível carregar o status do WhatsApp.'
            );
          }

          setWhatsApp(
            data.whatsapp
          );

          return data.whatsapp;
        } finally {
          setIsLoadingWhatsApp(
            false
          );
        }
      },
      []
    );

  useEffect(
    () => {
      void loadWhatsAppStatus();
    },
    [
      loadWhatsAppStatus,
    ]
  );

  return {
    whatsapp,
    isLoadingWhatsApp,
    loadWhatsAppStatus,
  };
}